import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Formik } from 'formik'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'
import { AnalyticsActions } from 'store/models/analytics'
import SupplierActions from 'store/models/supplier'
import { logout } from 'helpers/smartUtils'
import { LoginLoader, Toolbar } from 'components'
import { getChangedValues } from 'helpers'
import { OnboardingForm } from './OnboardingForm'
import schema from './schema'
import './styles.scss'

export const Register = () => {
    const dispatch = useDispatch()
    const history = useHistory()

    useEffect(() => {
        dispatch(AnalyticsActions.postAnalytics('[Register] componentDidMount', null))
    }, [])

    const { supplier, loadingReauthenticateSupplier } = useSelector(GET_STORE.SUPPLIER)

    const [isCompanyRegistered, setIsCompanyRegistered] = useState(true)
    const [isVATRegistered, setIsVATRegistered] = useState(true)
    const [primaryPhone, setPrimaryPhone] = useState('')
    const [financePhone, setFinancePhone] = useState('')

    const initialValues = {
        companyName: '',
        tradingName: '',
        primaryContactEmail: '',
        primaryContactPhone: '',
        financeEmail: '',
        financePhone: '',
        accountsPayableEmail: '',
        companyRegNumber: '',
        vatRegNumber: '',
        firstLine: '',
        secondLine: '',
        city: '',
        postCode: '',
        country: '',
    }

    const onSubmit = values => {
        const changedValues = getChangedValues(values, initialValues)

        const { tradingName, accountsPayableEmail, firstLine, secondLine, city, postCode, country } = changedValues

        const address = {
            firstLine,
            city,
            postCode,
            country,
        }

        if (secondLine) address.secondLine = secondLine

        const body = {
            address: JSON.stringify(address),
            supplierId: supplier.supplierId,
            ...changedValues,
        }

        delete body.firstLine
        delete body.city
        delete body.postCode
        delete body.country
        delete body.secondLine

        if (tradingName) body.tradingName = tradingName
        if (accountsPayableEmail) body.accountsPayableEmail = accountsPayableEmail
        if (!isCompanyRegistered) body.companyRegNumber = 'n/a'
        if (!isVATRegistered) body.vatRegNumber = 'n/a'

        dispatch(SupplierActions.updateSupplier(body))
    }

    if (!supplier || !Object.keys(supplier).length) {
        localStorage.clear()
        window.location.reload(false)
    }

    if (loadingReauthenticateSupplier) {
        return <LoginLoader />
    }

    return (
        <>
            <Toolbar buttonTitle="Logout" onButtonClicked={() => logout()} />
            <section className="section--beige section--fullscreen">
                <div className="sectionCentre sectionCentre--flex">
                    <div className="landing-container">
                        <div className="landing-card registrationFormWrapper">
                            <h1>Supplier Onboarding</h1>
                            <Formik {...{ enableReinitialize: true, initialValues, onSubmit, validationSchema: schema }}>
                                <OnboardingForm
                                    {...{
                                        financePhone,
                                        isCompanyRegistered,
                                        setIsVATRegistered,
                                        isVATRegistered,
                                        primaryPhone,
                                        setFinancePhone,
                                        setIsCompanyRegistered,
                                        setPrimaryPhone,
                                    }}
                                />
                            </Formik>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
